var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 97.141,
    height: 97.141,
    viewBox: "0 0 97.141 97.141",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-5512.089 -3017.324)",
    fill: "none",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#6e7e9d",
    d: "M5597.112 3087.566h12.118m-12.118-10.836h12.118m-12.118-10.835h12.118m-12.118-10.835h12.118m-12.118-10.836h12.118m-97.141 43.342h12.118m-12.118-10.836h12.118m-12.118-10.835h12.118m-12.118-10.835h12.118m-12.118-10.836h12.118m58.123-14.782v-12.118m-10.835 12.118v-12.118m-10.835 12.118v-12.118m-10.836 12.118v-12.118m-10.835 12.118v-12.118m43.341 97.142v-12.118m-10.835 12.118v-12.118m-10.835 12.118v-12.118m-10.836 12.118v-12.118m-10.835 12.118v-12.118"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 56.83,
    height: 56.83,
    rx: 7.05,
    transform: "translate(5532.245 3037.48)",
    stroke: "#0c9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 72.905,
    height: 72.905,
    rx: 11.009,
    transform: "translate(5524.207 3029.442)",
    stroke: "#0c9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5564.888 3080.752h-15.064v-4h15.064a4.607 4.607 0 100-9.214h-8.457a8.607 8.607 0 010-17.214h15.069v4h-15.064a4.607 4.607 0 000 9.214h8.457a8.607 8.607 0 110 17.214zm-2.829-30.428v-5.271m0 40.97v-5.271m-2.799-30.428v-5.271m0 40.97v-5.271",
    stroke: "#6e7e9d"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApi);
export default __webpack_public_path__ + "static/media/api.e6932da5532e9e1c572461ebcf57b808.svg";
export { ForwardRef as ReactComponent };